import React from 'react';
import { siteConfig } from '../../data/siteConfig';
export const LOGO_W = 556;
export const LOGO_H = 300;
interface LogoMaskDefsProps {
  id: string;
}

/**
 * Builds a luminance mask from the existing logo asset so the black background
 * drops out and only the gold "Q" remains — reused by every logo layer.
 */
export function LogoMaskDefs({
  id
}: LogoMaskDefsProps) {
  return <svg width="0" height="0" className="pointer-events-none absolute" aria-hidden="true" focusable="false" data-id="element-184" data-mp="s1yhmzt35zth">
      <defs data-id="element-185" data-mp="x1bca6q78b6m">
        <filter id={`${id}-boost`} colorInterpolationFilters="sRGB" data-id="element-186" data-mp="wzqhqh3vws8r">
          <feColorMatrix type="matrix" values="1.3 1.3 1.3 0 -0.35  1.3 1.3 1.3 0 -0.35  1.3 1.3 1.3 0 -0.35  0 0 0 1 0" data-id="element-187" data-mp="j1abssduj5ro" />
        </filter>
        <mask id={`${id}-mask`} maskUnits="userSpaceOnUse" x="0" y="0" width={LOGO_W} height={LOGO_H} data-id="element-188" data-mp="n1apubx19ey7">
          <image href={siteConfig.logoUrl} width={LOGO_W} height={LOGO_H} preserveAspectRatio="xMidYMid meet" filter={`url(#${id}-boost)`} data-id="element-189" data-mp="33qg4fchv9h0j" />
        </mask>
        <linearGradient id={`${id}-sheen`} x1="0" y1="0" x2="1" y2="0" data-id="element-190" data-mp="1tkdfmrm2ekfq">
          <stop offset="0" stopColor="#FFF8E8" stopOpacity="0" data-id="element-191" data-mp="1tmpzjabdv4vf" />
          <stop offset="0.5" stopColor="#FFF8E8" stopOpacity="0.6" data-id="element-192" data-mp="1omu2jv13sdpd" />
          <stop offset="1" stopColor="#FFF8E8" stopOpacity="0" data-id="element-193" data-mp="22lthuc2q7g8v" />
        </linearGradient>
      </defs>
    </svg>;
}